import type { ReactNode } from 'react'
import { Text } from '@/design-system'
import styles from './PageHeader.module.css'

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  readonly title: string
  readonly subtitle?: string | undefined
  readonly actions?: ReactNode | undefined
}) {
  return (
    <div className={styles.header}>
      <div className={styles.titles}>
        <Text as="h1" variant="title" weight="bold">
          {title}
        </Text>
        {subtitle && (
          <Text variant="caption" tone="secondary">
            {subtitle}
          </Text>
        )}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  )
}
